import styled from 'styled-components';

const Footer = styled.footer`
    color: var(--text-color);
    background: var(--background-color);
    border-top: 1px solid rgba(255,255,255,0.1);
`;

export default Footer;
